<template>
    <div>
        <img :class="customClass" v-if="imgSource" :src="imgSource" @load="$event => emitLoad($event)" />
        <span v-if="scaler && showScaler" @click="imgModal = {show: true, src: imgSource}" class="scaler shadow-sm"><FaIcon icon="search" /></span>

        <CModal v-if="scaler" :show.sync="imgModal.show" size="lg">
            <template #header-wrapper>
                <span></span>
            </template>

            <img class="w-100" :src="imgModal.src" />
            <template #footer-wrapper>
                <span></span>
            </template>
        </CModal>
    </div>
</template>

<script>
import { uploadService } from '@/services/api'

export default {
    name: 'CCustomImage',

    props: {
        src: {
            required: true,
        },
        isSecret: {
            default: false,
        },
        scaler: {
            default: false,
            type: Boolean,
        },
        customClass: {
            default: ''
        }
    },

    data() {
        return {
            imgSource: '',
            imgModal: {
                src: '',
                show: false
            },
            showScaler: false,
        }
    },

    methods: {
        emitLoad($event) {
            this.showScaler = true
            this.$emit('load', $event)
        },
    },

    async created() {
        if (this.isSecret) {
            let result = await uploadService.getSecret(this.src)
            let src = result.data ? result.data.data.url : ''

            this.imgSource = src //base ? `data:image/png;base64, ${base}` : ''
        } else {
            this.imgSource = this.src
        }

        this.showScaler = false
    }
}
</script>

<style lang="scss" scoped>
::v-deep .scaler {
    position: absolute;
    left: 50%;
    top: 50%;
    background-color: #fff;
    border-radius: 100%;
    height: 30px;
    width: 30px;
    cursor: pointer;

    svg {
        padding-top: 9px;
        padding-right: 8px;
    }
}
</style>